"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { Component, Vue } from "vue-property-decorator";
import UiDialog, { UiDialogController } from "@/components/dialog/UiDialog.vue";
import API from "@ym-framework/api-utils";
let CreateSafeSuccessDialog = class extends Vue {
  constructor() {
    super(...arguments);
    this.dialog = new UiDialogController();
    this.vd_name = "";
    this.recommand_data = [];
  }
  open(vd_info) {
    return __async(this, null, function* () {
      try {
        if (vd_info) {
          console.log(vd_info);
          this.vd_name = vd_info;
        }
        let response = yield API.get("api://base.auth/api/v7/novice-problem");
        this.recommand_data = response.data.datas;
        this.dialog.visible = true;
      } catch (error) {
      }
    });
  }
  closeSuccessDialog() {
    this.dialog.visible = false;
  }
  openNewGuidDialog() {
    this.$emit("openGuideDialog");
    this.dialog.visible = false;
  }
  moreQuestions() {
  }
  questionItem(url) {
    window.open(url, "_blank");
  }
};
CreateSafeSuccessDialog = __decorateClass([
  Component({
    components: {
      UiDialog
    }
  })
], CreateSafeSuccessDialog);
export {
  CreateSafeSuccessDialog as default
};
